import catalog from './currencies.json';

export const CURRENCIES = catalog.currencies;
const currenciesByCode = new Map(
  CURRENCIES.map((currency) => [currency.code, currency])
);

export const CURRENCY_LOCALES = [
  'en-CA',
  'fr-CA',
  'en-US',
  'en-GB',
  'en-AU',
  'en-NZ',
  'de-DE',
  'fr-FR',
  'de-CH',
  'fr-CH',
  'it-IT',
  'es-ES',
  'es-MX',
  'pt-BR',
  'pt-PT',
  'nl-NL',
  'ja-JP',
  'zh-CN',
  'zh-TW',
  'zh-HK',
  'ko-KR',
  'en-IN',
  'hi-IN',
  'ar-AE',
  'ar-SA',
  'ar-KW',
  'ar-BH',
  'he-IL',
  'sv-SE',
  'nb-NO',
  'da-DK',
  'pl-PL',
  'cs-CZ',
  'hu-HU',
  'tr-TR',
  'id-ID',
  'ms-MY',
  'th-TH',
  'vi-VN',
  'en-ZA'
];

export const normalizeCurrencyLocale = (locale) => {
  if (typeof locale !== 'string' || !locale.trim() || locale.length > 64)
    return null;
  try {
    const canonical = Intl.getCanonicalLocales(locale.trim())[0];
    return Intl.NumberFormat.supportedLocalesOf([canonical], {
      localeMatcher: 'lookup'
    }).length
      ? canonical
      : null;
  } catch {
    return null;
  }
};

export const normalizeCurrencyConfig = (config) => {
  if (config.format !== 'currency') return { config: {} };
  if (!currenciesByCode.has(config.currency))
    return { error: 'Select a currency.' };
  const locale = normalizeCurrencyLocale(config.locale);
  if (!locale)
    return {
      error: 'Enter a supported display locale, such as en-CA or fr-CA.'
    };
  return { config: { currency: config.currency, locale } };
};

export const formatCurrencyValue = (
  value,
  config,
  { compact = false } = {}
) => {
  const currency = currenciesByCode.get(config.currency);
  const locale = normalizeCurrencyLocale(config.locale);
  // Part 1 allowed the currency category without currency settings. Do not
  // guess a currency or change the displayed meaning of those legacy fields.
  if (!currency || !locale) return null;
  const precision =
    Number.isInteger(config.decimal_places) &&
    config.decimal_places >= 0 &&
    config.decimal_places <= 20
      ? config.decimal_places
      : currency.minorUnits;
  const parts = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency.code,
    currencyDisplay: 'narrowSymbol',
    ...(compact ? { notation: 'compact' } : {}),
    ...(precision !== null
      ? {
          minimumFractionDigits: compact ? 0 : precision,
          maximumFractionDigits: compact ? 2 : precision
        }
      : {})
  }).formatToParts(value);
  const amount = parts.map((part) => part.value).join('');
  // Some currencies have no distinct symbol in CLDR: their code is the symbol.
  return parts.some(
    (part) => part.type === 'currency' && part.value === currency.code
  )
    ? amount
    : amount + ' ' + currency.code;
};
